import {useMemo} from 'react'

import type {BuildId} from '../../../../types'
import type {BuildState} from '../../../common/BuildStateFilter/BuildStateFilter.constants'
import {useQueryStateMatrixBuild} from '../MatrixBuild.hooks'
import type {ParametersFilter} from '../MatrixBuild.types'
import {filterBuildMatrix, getBuildMatrix, getFullMatrix} from '../MatrixBuild.utils'

export const useGenerateMatrix = (
  buildId: BuildId,
  stateFilter: BuildState,
  parametersFilter: ParametersFilter | null,
) => {
  const {dependencies, parameters, buildsHash} = useQueryStateMatrixBuild(buildId)

  const initialBuildMatrix = useMemo(
    () => getBuildMatrix(parameters, dependencies, buildsHash),
    [parameters, dependencies, buildsHash],
  )
  const filteredBuildMatrix = filterBuildMatrix(initialBuildMatrix, stateFilter, parametersFilter)

  return getFullMatrix(filteredBuildMatrix, parameters)
}
